import React, { useState, useEffect } from 'react';
import CallAPI from '../../../../../adminpanel/components/commonComponents/AxiosHelper';
// import Form from '../../../../../adminpanel/components/commonComponents/Form.v2';
import Form from '../../../../../adminpanel/components/commonComponents/Form';
import { connect } from 'react-redux';

const icons = {
    "mysql": { "name": 'MySQL', id: "mysql", type: 'databases' },
    // "files": { "name": 'Files', id: "files", type: 'databases' },
    "sftp": { "name": 'SFTP', id: "sftp", type: 'databases' },
    "sqlserver": { "name": 'SQL Server', id: "sqlsrv", type: 'databases' },
    "oracle": { "name": 'Oracle', id: "oracle", type: 'databases' },
    "postgres": { "name": 'Postgres', id: "postgres", type: 'databases' },
    "mysql_tally": { "name": 'Tally', id: "mysql_tally", type: 'application' }
};

function StepOne({ authData, ...props }) {

    const [dropDownVal, setdropDownVal] = useState("");
    const [typeDropdown, setTypeDropdown] = useState("");
    const [dropdownArr, setdropdownArr] = useState([]);
    const [iconState, setIconState] = useState(icons)

    useEffect(() => {
        let params = {
            siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
            companyName: authData.companyName
        }

        CallAPI('get', '/app/get_database_connector', null, params, 0, function (response) {
            if (response.status === true) {
                let dropdownArray = { 0: { "name": "Select Connection", "value": "", "connection_type": null } };
                if (response.information.length > 0) {
                    response.information.map(el => {
                        el = JSON.parse(decodePassword(el))
                        if (iconState?.['files'] && el.connection_type == "manual" && !iconState?.['files']?.['connectionId']) {
                            iconState['files']['connectionId'] = el.id;
                        }
                        dropdownArray[el.id] = { "name": `${el.connection_name}`, "value": `${el.id}`, "connection_type": `${el.connection_type}` }
                    });
                    setdropdownArr(dropdownArray);
                    setIconState(iconState)
                }
            } else {
                let dropdownArray = { 0: { "name": "No Connections Available", "value": "", "connection_type": null } };
                setdropdownArr(dropdownArray);
            }
        }, authData)
    }, [])

    const handleChange = (e) => {
        setdropDownVal(e.target.value);
    };

    const handleTypeChange = (e) => {
        setTypeDropdown(e.target.value);
        HandleTypeSubmit(e.target.value);
    }

    const HandleTypeSubmit = (e) => {
        let results = {}
        setIconState(icons)
        if(e === 'databases'){
            results = Object.keys(icons).reduce(function(acc, val) {
                if(icons[val].type === 'databases')  acc[val] = icons[val];
              return acc;
            }, {});
            setIconState(results)
        }else if(e === 'application'){
            results = Object.keys(icons).reduce(function(acc, val) {
                if(icons[val].type === 'application')  acc[val] = icons[val];
              return acc;
            }, {});
            setIconState(results)
        }else {
            setIconState(icons)
        }
    }

    const handleSubmit = (event) => {
        var formData = {}
        $("#connectionSelect").serializeArray().map(function (innerData) {
            formData[`${innerData.name}`] = `${innerData.value}`;
        })
        if (dropdownArr[formData.selectExistingConnection]["connection_type"] === "manual" || dropdownArr[formData.selectExistingConnection]["connection_type"] === "files") {
            props.setConnectionType({
                "connectionId": formData.selectExistingConnection,
                selectedStep: 2,
                "connection_type": 'files',
                "connection_name": dropdownArr[formData.selectExistingConnection]["name"]
            })
        } else {
            props.setConnectionType({
                "connectionId": formData.selectExistingConnection,
                selectedStep: 3,
                "connection_type": dropdownArr[formData.selectExistingConnection]["connection_type"],
                "connection_name": dropdownArr[formData.selectExistingConnection]["name"]
            })
        }
        event.preventDefault();
    }

    const formVar = {
        "selectExistingConnection": {
            "name": "selectExistingConnection",
            "key": `sortKey${Math.floor(Math.random() * 10)}`,
            "label": "Select Existing Connection",
            "type": "dropdown",
            "text_value": dropDownVal,
            "options": [],
            "requiredFlag": true,multiple: false,"searchEnabled": true,
        }
    }

    const typeForm = {
        "selectType": {
            "name": "selectType",
            "key": `sortKey${Math.floor(Math.random() * 10)}`,
            "label": "Select Type",
            "type": "dropdown",
            "text_value": typeDropdown,
            "options": [
                {"name": "All", "value": "all"},
                {"name": "Databases", "value": "databases"},
                {"name": "Application", "value": "application"}
            ],
            "searchEnabled": false,
           
        }
    }

    formVar['selectExistingConnection'].options = Object.values(dropdownArr);

    const cardNodes = Object.values(iconState).map(function (item, index) {
        let icon = item.icon ? item.icon : `/assets/connectionType/${item.id.toLowerCase()}.png`;
        return (
            <div className="col-md-3 mg-t-10" key={`${item.connection_type}_${index}_${item.connectionId}`}>
                <div className="card text-center">
                    <div className="card-body">
                        <img width={80} height={80} src={`${icon}`} />
                        <h5 className="mg-t-5">{`${item.name}`}</h5>
                    </div>
                    <div className="card-footer"><button className="btn btn-primary btn-sm" onClick={() => props.setConnectionType({ "connection_type": item.id, selectedStep: 2, connectionId: item.connectionId ? item.connectionId : null, "connection_type_label": item.name })}>Connect</button></div>
                </div>
            </div>
        )
    });

    return (
        <>
            <label className="d-block tx-medium tx-12 tx-uppercase tx-sans tx-spacing-1 tx-color-03 mg-b-15 mg-t-15">Select Existing Connection</label>
            <div className="row">
                <div className="col-md-3 mg-t-10">
                    <Form label_array={typeForm} handle_form_drop_down={handleTypeChange} />
                    <form id="connectionSelect" onSubmit={handleSubmit}>
                        <Form label_array={formVar} handle_form_drop_down={handleChange} />
                        <button type="submit" className="btn btn-primary">Confirm</button>
                    </form>
                </div>
            </div>
            <label className="d-block tx-medium tx-12 tx-uppercase tx-sans tx-spacing-1 tx-color-03 mg-b-15 mg-t-15">Create New Connection</label>
            <div className="row">
                {cardNodes}
            </div>
        </>
    )
}

function mapStateToProps(state) {
    return { authData: state.dataSet.authData };
}

export default connect(mapStateToProps, null)(StepOne);